<div class="content-card p-6">
  <h3 class="text-lg font-semibold text-gray-900 mb-4">Nova Lição</h3>

  <form [formGroup]="lessonForm" (ngSubmit)="onSave()" class="space-y-4">
    <div>
      <label
        for="lesson-title"
        class="mb-1 block text-sm font-medium text-gray-700"
      >
        Título da Lição *
      </label>
      <input
        type="text"
        id="lesson-title"
        formControlName="title"
        class="form-field-control placeholder-gray-500"
        [class.border-red-500]="isFieldInvalid('title')"
        placeholder="Digite o título da lição"
      />
      @if (isFieldInvalid('title')) {
      <p class="mt-1 text-sm text-red-600">{{ getFieldError('title') }}</p>
      }
    </div>

    <div>
      <label
        for="lesson-description"
        class="mb-1 block text-sm font-medium text-gray-700"
      >
        Descrição *
      </label>
      <textarea
        id="lesson-description"
        formControlName="description"
        rows="3"
        class="form-field-textarea placeholder-gray-500"
        [class.border-red-500]="isFieldInvalid('description')"
        placeholder="Digite a descrição da lição"
      ></textarea>
      @if (isFieldInvalid('description')) {
      <p class="mt-1 text-sm text-red-600">
        {{ getFieldError('description') }}
      </p>
      }
    </div>

    <div class="grid grid-cols-2 gap-4">
      <div>
        <label
          for="lesson-type"
          class="mb-1 block text-sm font-medium text-gray-700"
        >
          Tipo de Lição *
        </label>
        <select
          id="lesson-type"
          formControlName="type"
          class="form-field-control"
        >
          @for (type of lessonTypes; track type.value) {
          <option [value]="type.value">{{ type.label }}</option>
          }
        </select>
      </div>

      <div>
        <label
          for="lesson-duration"
          class="mb-1 block text-sm font-medium text-gray-700"
        >
          Duração (minutos) *
        </label>
        <input
          type="number"
          id="lesson-duration"
          formControlName="duration"
          min="1"
          class="form-field-control placeholder-gray-500"
          [class.border-red-500]="isFieldInvalid('duration')"
          placeholder="0"
        />
        @if (isFieldInvalid('duration')) {
        <p class="mt-1 text-sm text-red-600">{{ getFieldError('duration') }}</p>
        }
      </div>
    </div>

    @if (lessonForm.get('type')?.value === 'video') {
    <div>
      <label
        for="lesson-video-url"
        class="mb-1 block text-sm font-medium text-gray-700"
      >
        URL do Vídeo (Embed) *
      </label>
      <input
        type="url"
        id="lesson-video-url"
        formControlName="videoUrl"
        class="form-field-control placeholder-gray-500"
        [class.border-red-500]="isFieldInvalid('videoUrl')"
        placeholder="https://www.youtube.com/embed/VIDEO_ID"
      />
      @if (isFieldInvalid('videoUrl')) {
      <p class="mt-1 text-sm text-red-600">{{ getFieldError('videoUrl') }}</p>
      }
      <p class="mt-1 text-xs text-blue-800">
        Use URL de embed do YouTube (ex: https://www.youtube.com/embed/VIDEO_ID)
      </p>
    </div>
    } @if (lessonForm.get('type')?.value === 'pdf') {
    <div>
      <label
        for="lesson-pdf-url"
        class="mb-1 block text-sm font-medium text-gray-700"
      >
        URL do PDF *
      </label>
      <input
        type="url"
        id="lesson-pdf-url"
        formControlName="pdfUrl"
        class="form-field-control placeholder-gray-500"
        [class.border-red-500]="isFieldInvalid('pdfUrl')"
        placeholder="https://exemplo.com/documento.pdf"
      />
      @if (isFieldInvalid('pdfUrl')) {
      <p class="mt-1 text-sm text-red-600">{{ getFieldError('pdfUrl') }}</p>
      }
      <p class="mt-1 text-xs text-blue-800">URL do arquivo PDF a ser exibido</p>
    </div>
    }

    <div
      class="form-actions flex items-center justify-end gap-3 border-t border-gray-200 pt-4"
    >
      <button type="button" class="btn-secondary" (click)="onCancel()">
        Cancelar
      </button>
      <button type="submit" class="btn-primary" [disabled]="lessonForm.invalid">
        Criar Lição
      </button>
    </div>
  </form>
</div>
